export default {
  path: '/systemLog',
  name: '',
  component: () => import('@/components/layout/layout.vue'),
  redirect: '/systemLog/home',
  children: [
    {
      path: 'index',
      name: 'systemLog_index',
      component: () => import('./index')
    },
  ]
}



// WEBPACK FOOTER //
// ./src/pages/systemLog/router_systemLog.js